import ButtonParagraf from './ButtonParagraf';
import Wrapper from './Wrapper';
import EmptyTableWrapper from "./EmptyTableWrapper";
import EmptyVoucher from "./EmptyVoucher";
const FontPrimary = 'Montserrat Light';
const FontPrimaryBold = 'Montserrat Bold';
const FontPrimarySemiBold = 'Montserrat Semi Bold';
const FontNunitoRegular = 'Nunito Regular';
const FontNunitoBold = 'Nunito Bold';
const FontNunitoSemiBold = 'Nunito SemiBold';
const FontNunitoLight = 'Nunito Light';

export {
  ButtonParagraf,
  Wrapper,
  FontPrimary,
  FontPrimaryBold,
  FontPrimarySemiBold,
  EmptyTableWrapper,
  FontNunitoRegular,
  FontNunitoBold,
  FontNunitoSemiBold,
  FontNunitoLight,
  EmptyVoucher
}
